import Slider from "react-slick";
import SingleBrandItem from "./ClientSingle";
import { BASE_URL } from "../../constants";
const ClientSection = () => {
  // slick setting
  const settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <section
        className="brand__area pt-90 pb-100"
        style={{
          backgroundColor:`rgba(246, 246, 246, 1);`,
          backgroundPosition: "top",
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="section__title text-center mb-50">
                <h2 className="client-heading">Our Trusted Collaborators</h2>
                <span>Empowering Sustainability Together</span>
              </div>
            </div>
          </div>
          <div className="row">
            <Slider className="brand-active" {...settings}>
              <SingleBrandItem img_1="1" />
              <SingleBrandItem img_1="2" />
              <SingleBrandItem img_1="3" />
              <SingleBrandItem img_1="4" />
              <SingleBrandItem img_1="5" />
              <SingleBrandItem img_1="1" />
              <SingleBrandItem img_1="2" />
              <SingleBrandItem img_1="3" />
              <SingleBrandItem img_1="4" />
              <SingleBrandItem img_1="5" />
            </Slider>
          </div>
        </div>
      </section>
    </>
  );
};

export default ClientSection;
